export default __webpack_public_path__ + "static/media/kadena_kad.c769eb4e.png";